import { Box, Tooltip, Paper, RouterLink, Link } from 'components/common';
import {
	useCopyLink,
	useCurrentCommunity,
	useRouter,
	useTranslation,
	useVerifyAccess,
} from 'hooks';
import { EnvelopIcon } from 'components/common/icons/envelop-icon';
import { LinkIcon } from 'components/common/icons/link-icon';

export const EventShareCard = () => {
	const community = useCurrentCommunity();
	const { t } = useTranslation();
	const router = useRouter();
	const verify = useVerifyAccess();

	const { url, isCopied, handleOnCopy } = useCopyLink();

	const canInviteMembers = verify('create', 'member');

	return (
		<Box component={Paper} elevation={0} px={0} py={1}>
			{canInviteMembers ? (
				<RouterLink
					variant='button'
					to={router.getPathFor('community.invite', {
						communityId: community?.slug,
					})}
				>
					<EnvelopIcon />
					{t('event.add-members')}
				</RouterLink>
			) : (
				<Link
					href={t('community-home.mail-to-link', {
						joinUrl: url,
						communityName: community?.name,
						partner: community?.partner?.name,
					})}
					variant='button'
					target='_blank'
				>
					<EnvelopIcon />
					{t('community-home.add-members')}
				</Link>
			)}
			<Tooltip
				open={isCopied}
				title={<>{t('event.was-copies', { url })}</>}
				placement='top'
			>
				<Link variant='button' onClick={handleOnCopy}>
					<LinkIcon />
					{t('event.link-of-chain')}
				</Link>
			</Tooltip>
		</Box>
	);
};
